// extracted by css-extract-rspack-plugin
export default {"scrollContainer":"Comments-module__scrollContainer__t1dWz"};